export default __webpack_public_path__ + "a71117177f4461757115791f3f28da04.svg";